__webpack_require__.p = "https://genqr.eu/";